import { call, put } from 'redux-saga/effects'
import { PayloadAction } from '@reduxjs/toolkit'
import apiMiddleware from 'services/api_middleware'
import app_config from 'config/app_config'

import { onOpenNotification } from 'redux/notification/reducer'
import {
	invoiceChangelogsRequestFailure,
	invoiceChangelogsRequestSuccess,
} from '../reducer'
import { IInvoiceChangelog } from '../types'

export function* getInvoiceChangelogsSaga({
	payload,
}: PayloadAction<{ id: string }>) {
	try {
		const { changelogs }: {
			changelogs: IInvoiceChangelog[]
		} = yield call(apiMiddleware, {
			url: `${app_config.services.getInvoiceChangelogs}/${payload.id}`,
		})

		yield put(invoiceChangelogsRequestSuccess(changelogs))
	} catch (e) {
		yield put(invoiceChangelogsRequestFailure())

		const error = e as { message: string }

		yield put(
			onOpenNotification({
				message: error.message,
				notificationType: 'error',
			})
		)
	}
}
